// GETTERS
export const GET_USER = 'user/GET_USER';
export const GET_USER_LIST = 'user/GET_USER_LIST';


// MUTATORS
export const MUTATE_USER = 'user/MUTATE_USER';
export const MUTATE_LIST_USER = 'user/MUTATE_LIST_USER';


// ACTIONS
export const AUTHENTICATE = 'user/AUTHENTICATE';
export const ACTION_LIST_USER = 'user/ACTION_LIST_USER';
export const ACTION_DELETE = 'user/ACTION_DELETE';
export const ACTION_UPDATE = 'user/ACTION_UPDATE';
export const ACTION_ADD = 'user/ACTION_ADD';
export const ACTION_GET_USER = 'user/ACTION_GET_USER';


// WEBPACK FOOTER //
// ./src/store/constants/user.js